var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89848 15.8146H5.15848C2.78848 15.8146 2.00098 14.2396 2.00098 12.6571V6.34207C2.00098 3.97207 2.78848 3.18457 5.15848 3.18457H9.89848C12.2685 3.18457 13.056 3.97207 13.056 6.34207V12.6571C13.056 15.0271 12.261 15.8146 9.89848 15.8146Z",
    stroke: "#f9bc03",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.139 13.3251L13.054 11.8626V7.1301L15.139 5.6676C16.159 4.9551 16.999 5.3901 16.999 6.6426V12.3576C16.999 13.6101 16.159 14.0451 15.139 13.3251ZM9.12402 8.7501C9.42239 8.7501 9.70854 8.63157 9.91952 8.42059C10.1305 8.20962 10.249 7.92347 10.249 7.6251C10.249 7.32673 10.1305 7.04058 9.91952 6.8296C9.70854 6.61863 9.42239 6.5001 9.12402 6.5001C8.82565 6.5001 8.53951 6.61863 8.32853 6.8296C8.11755 7.04058 7.99902 7.32673 7.99902 7.6251C7.99902 7.92347 8.11755 8.20962 8.32853 8.42059C8.53951 8.63157 8.82565 8.7501 9.12402 8.7501Z",
    stroke: "#f9bc03",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCam);
export default __webpack_public_path__ + "static/media/videoCam.116019019082857e48b1a4f5898440d7.svg";
export { ForwardRef as ReactComponent };